import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { Link, useHistory } from 'react-router-dom';
import { Box, Container, CssBaseline, Slide } from '@material-ui/core';
import { SettingMenu } from '../../../feature/setting/components/setting-menu';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { checkIsLogin } from '../../../services/global/global.service';
import { GlobalContext } from '../../../services/global/GlobalState';

const useStyles = makeStyles((theme) => ({
  mizbanBrand: {
    textDecoration: 'none',
    color: theme.brand.primary,
    fontWeight: 500,
    fontSize: 20,
    marginLeft: 6,
  },
  menuButton: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  appBar: {
    background: '#FAFAFA',
    boxShadow:
      '1px -7px 0px -4px rgb(0 0 0 / 20%), -6px -5px 5px 0px rgb(0 0 0 / 14%), -2px -4px 10px 2px rgb(0 0 0 / 12%)',
    [theme.breakpoints.down('xs')]: {
      paddingRight: 16,
      paddingLeft: 16,
    },
  },
  appBarBtn: {
    color: theme.bg.tertiary,
    backgroundColor: theme.ui.tertiary,
  },
  skeleton: {
    width: 180,
    height: 45,
  },
  box: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  mizbanIcon: {
    height: 48,
    [theme.breakpoints.down('sm')]: {
      height: 36,
    },
  },
  container: {
    display: 'flex',
    maxWidth: 1032,
    alignItems: 'center',
    padding: 0,
  },
}));

const HideOnScroll = (props) => {
  const { children, window } = props;
  const { setIsScroll } = useContext(GlobalContext);
  const trigger = useScrollTrigger(window);

  useEffect(() => {
    setIsScroll(trigger);
  }, [trigger]);

  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
};

export const Navbar = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const [navbarStatus, setNavBarStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkIsLogin(setNavBarStatus, setIsLoading);
  }, []);

  const Menu = () => (
    <div>
      <Button
        color='inherit'
        onClick={() =>
          history.push({
            pathname: '/signin',
            state: '/meetings',
          })
        }
      >
        Sign in
      </Button>
      <Button
        color='inherit'
        onClick={() =>
          history.push({
            pathname: '/signup',
            state: '/meetings',
          })
        }
      >
        Sign up
      </Button>
    </div>
  );

  const NavbarContainer = () => {
    if (navbarStatus === 1) {
      return <SettingMenu />;
    } else {
      // return <Menu />;
      return null;
    }
  };

  return (
    <>
      <CssBaseline />
      <HideOnScroll {...children}>
        <AppBar className={classes.appBar} position='fixed'>
          <Toolbar>
            <Container className={classes.container}>
              <Box className={classes.box}>
                <img
                  className={classes.mizbanIcon}
                  src={process.env.PUBLIC_URL + '/icons/mizban.svg'}
                  alt='mizban'
                />
                <Link to='/' className={classes.mizbanBrand}>
                  Mizban
                </Link>
              </Box>
              {/* {isLoading ? (
                <Skeleton className={classes.skeleton} animation='wave' />
              ) : (
                )} */}
              <NavbarContainer />
            </Container>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
    </>
  );
};
